import type { FC } from "react"
import { useLocation, useParams } from "react-router-dom"
import { useRequest } from "ahooks"
import classNames from "classnames"
import { useConfigModel } from "@/models"
import { SandtableType, getCitys } from "@/api"
import type { RouterIdsVO } from "@/api"
import { isShowConfig } from "@/util/commonUtils"
import "./index.scss"
// ==============================================
import Avatar from "@/components/Header/components/Avatar"
// ==============================================
const HeaderPark: FC<any> = () => {
  const { cityId } = useParams<RouterIdsVO>() as any
  const location = useLocation()
  const pathArr = location.pathname.split("/")
  const isShow = isShowConfig()
  const { setCurrentConfig, setConfigs } = useConfigModel()

  // 获取当前配置
  useRequest(
    () =>
      getCitys({
        cityId,
        sandTableType: SandtableType.PARK,
      }),
    {
      refreshDeps: [cityId],
      onSuccess: (res) => {
        const area = res?.area?.slice() || []

        setCurrentConfig({
          ...res,
        })
        setConfigs(area)
      },
      onError: () => {
        setConfigs([])
      },
    },
  )

  return (
    <div className={classNames("header-park", `container-${pathArr[pathArr.length - 1]}`)}>
      {/* 头像 */}
      <Avatar isShowConfig={isShow} />
      {/* header */}
      <div className="header-top">
        <div className="show-name">WAYZCITY 城市体征</div>
      </div>
    </div>
  )
}

export default HeaderPark
